import React, {useState} from 'react'
import styled from 'styled-components'
import ReactModal from 'react-modal'

import MODAL_STYLES from '~/components/modals/styles'
import Spacer from '~/components/Spacer'
import Input from "~/components/Form/Input"
import * as StringTools from '~/utilities/string'
import FixedCloseButton from '~/components/modals/FixedCloseButton'
import colors from '~/style/theme/colors'


const Text = styled.div`
  width: 100%;
  color: ${props => props.color ? props.color : props.theme.colors.text.header};
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  font-size: ${props => props.fontSize ? props.fontSize : ".9em"};
  text-align: center;
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const InnerContainer = styled.div`
  width: 200px;
`

const CalculateModal = ({isOpen, close, isMobile}) => {
  const [number, setNumber] = useState(0)
  const INTEGER_MAX = 999999
  const handleChange = (e) => {
    const rawInput = e.target.value
    const digitInput = StringTools.removeNonDigits(rawInput)
    if (digitInput < INTEGER_MAX) {
      setNumber(digitInput)
    }
  }

  return (
    <ReactModal
      closeTimeoutMS={300}
      isOpen={isOpen}
      style={isMobile ? MODAL_STYLES.mobile.general : MODAL_STYLES.desktop.general}
      onRequestClose={close}
    >
      <FixedCloseButton
        color={isMobile ? 'black' : 'white'}
        onClick={close}
      />
      <Spacer mobile={50} desktop={20} />
      <Text color={colors.primary}>SEE HOW MUCH YOU CAN SAVE</Text>
      <Spacer mobile={10} desktop={20} />

      <Text fontSize="2em">We take 50% of the fine, only if you win.</Text>

      <Spacer mobile={10} desktop={20} />

      <Text fontSize=".75em" color={colors.text.label}>
        If your ticket is found guilty, you don’t owe WinIt for the dispute, but keep in mind that you will have to pay the NYC Department of Finance. WinIt offers ticket payment processing services, which include a $5.99 service charge and a 3% processing fee.
      </Text>

      <Spacer mobile={10} desktop={20} />

      <InputContainer>
        <InnerContainer>
          <Input onChange={handleChange} value={number || ""} />
        </InnerContainer>
      </InputContainer>

      <Spacer mobile={20} desktop={30} />

      <Text>How much can you save?</Text>

      <Spacer mobile={20} desktop={20} />

      <Text fontSize="2em" color={colors.success}>${(number/2).toFixed(2)}</Text>

      <Spacer mobile={20} desktop={20} />

    </ReactModal>
  )
}

export default CalculateModal

